/**
 * Created by Jonas Wålekvist on 2017-12-11.
 */

import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {
    IStillImageBgIntroViewConfig,
    StillImageBgIntroView
} from "@nolimitcity/slot-game/bin/game/intro/StillImageBgIntroView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {PixiesVsPiratesGameAssets} from "../PixiesVsPiratesGameAssets";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IBoxConfig, SpritePageFlipper} from "./pageFlipper/SpritePageFlipper";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";

export class PixiesVsPiratesIntroView extends StillImageBgIntroView {

    private _board:PIXI.Sprite;
    private _pageFlipView:SpritePageFlipper;
    private _pageBoxConfig:IBoxConfig [] = [];

    private _logo:PIXI.Sprite;
    private _gfxContainer:PIXI.Container;

    private _xNudge:PIXI.Sprite;
    private _xWays:PIXI.Sprite;

    constructor(config:IStillImageBgIntroViewConfig) {
        super(config);
    }

    public startPresentation(data?: ParsedServerData, onShowComplete?: () => void):void {
        super.startPresentation(data, onShowComplete);

        this._pageFlipView.forceInitAnimations();
        this._pageFlipView.interactEnabled = true;
        this._pageFlipView.slideShowEnabled = true;
        this._pageFlipView.startSlideShow(7);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._gfxContainer = new PIXI.Container();

        this._board = new PIXI.Sprite(GameResources.getTextures("introBoard")[0]);
        this._board.anchor.set(0.5, 0.5);


        this._logo = new PIXI.Sprite(GameResources.getTextures(PixiesVsPiratesGameAssets.INTRO_LOGO)[0]);
        this._logo.anchor.set(0.5, 0);


        this._gfxContainer.addChild(this._board);
        this._gfxContainer.addChild(this._logo);

        // pageFlipper
        const arrowUp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("navArrow")[0]);
        const arrowDown:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("navArrow")[0]);
        arrowDown.scale.set(-1, -1);

        const mysteryChestComp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("mysteryChest")[0]);
        const xWays:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("xWaysLogoIntro")[0]);
        xWays.anchor.set(1.25, 0);
        xWays.y = 265;
        mysteryChestComp.addChild(xWays);
        this._xWays = xWays;

        const nudgeWildComp:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wildNudgeIntro")[0]);
        const xNudge:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("xNudgeLogoIntro")[0]);
        xNudge.anchor.set(1.25, 0);
        xNudge.y = 265;
        nudgeWildComp.addChild(xNudge);
        this._xNudge = xNudge;

        this._pageBoxConfig =  [
            {
                //backgroundTexture: GameResources.getTextures("infoBg")[0],
                infoSprite: mysteryChestComp,
                title: "Mystery Chest",
                text: Translation.translate("The xWays Mystery Chest can hold 1-4 symbols inside and may expand the reels!"),
                additionalInfo: [Translation.translate("win more than"), "11 000x", Translation.translate("bet")]
            },
            {
                title: "xNudge Wild",
                infoSprite: nudgeWildComp,
                text: Translation.translate("Each Wild Nudge increases multiplier!"),
                additionalInfo: [Translation.translate("win more than"), "11 000x", Translation.translate("bet")]
            },
            {
                title: "Battle Rounds",
                infoSprite: new PIXI.Sprite(GameResources.getTextures("battleRoundsIntro")[0]),
                text: Translation.translate("Collect Pixie Queen or Pirate Captain to win the battle and retrigger Battle Rounds!"),
                additionalInfo: [Translation.translate("win more than"), "11 000x", Translation.translate("bet")]
            }
        ];
        this._pageFlipView = new SpritePageFlipper(
            arrowUp,
            arrowDown,
            this._pageBoxConfig
        );
        this._gfxContainer.addChild(this._pageFlipView);

        return this._gfxContainer;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._board.scale.set(1.45, 1.45);
            this._board.position.set(0, 0);

            this._logo.scale.set(1.65, 1.65);
            this._logo.position.set(0, -400);

            this._pageFlipView.scale.set(1.85, 1.85);
            this._pageFlipView.position.set(-319, /*featureY*/ -48);

            this._gfxContainer.position.set(this._screenWidth / 2, this._screenHeight * 0.3);

            this._xWays.position.set(25, 255);
            this._xNudge.position.set(25, 255);
        }
        else {
            this._board.scale.set(1, 1);
            this._board.position.set(0, 50);

            this._pageFlipView.scale.set(1.2, 1.2);
            this._pageFlipView.position.set(-195, /*featureY*/ 30);

            this._logo.scale.set(1, 1);
            this._logo.position.set(0, -60);

            this._gfxContainer.position.set(this._screenWidth / 2 , this._screenHeight * 0.1);

            this._xWays.position.set(0, 265);
            this._xNudge.position.set(0, 265);
        }
    }
}
